export default "__VITE_ASSET__BPQih470__"